import styles from "./styles.module.scss";
import bulkDownloader from "~/stores/bulkDownloader";
import { Button } from "~/components/ui/button";
import { observer } from "mobx-react";
import cn from "classnames";
import { X } from "lucide-react";
import { ReqStatus } from "~/api";
import { useContext } from "react";
import { ToastNotificationContext } from "~/components/ToastNotificationContext";

const BulkDownloadModal = observer(() => {
  const { setNotificationData, showNotificationWithTimeout } = useContext(ToastNotificationContext);
  if (!bulkDownloader.selectedSomething) return null;
  const downloading = bulkDownloader.status === ReqStatus.InProcess;
  return (
    <div className={cn(styles.modal, "overflow-hidden rounded-lg border shadow-lg")}>
      <div className="border-b px-4 py-2.5 text-xs font-semibold [color:var(--text-02)]">
        Bulk download ({bulkDownloader.selectedDocumentsList.length} items)
      </div>
      <div className={styles.content}>
        <ul className={styles.docList}>
          {bulkDownloader.selectedDocumentsList.map((item) => {
            const deselect = () => bulkDownloader.setBulkDownloadSelected(item, false);
            return (
              <li key={item.protocol} className={cn("flex flex-row items-start justify-between", styles.listItem)}>
                <div>
                  <div className="mr-2 text-sm font-semibold">{item.title}</div>
                  <div className="text-xs [color:var(--text-02)]">5 MB</div>
                  <div className="text-xs [color:var(--text-02)]">{item.protocol}</div>
                </div>
                <Button variant="ghost" size="icon" title="Deselect" onClick={deselect}>
                  <X className="size-4" />
                </Button>
              </li>
            );
          })}
        </ul>
        <div className="flex-[1_1_100%]" />
        <div className={styles.actions}>
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={async () => {
                const ok = await bulkDownloader.download();
                if (ok) {
                  bulkDownloader.clearSelection();
                } else {
                  setNotificationData({ kind: "error", title: "Failed to download ZIP" });
                  showNotificationWithTimeout();
                }
              }}
              disabled={downloading}
            >
              Download ZIP
            </Button>
            <Button variant="destructive" onClick={bulkDownloader.clearSelection} disabled={downloading}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default BulkDownloadModal;
